import {z} from 'zod';

import {API_PARAMETERS_TYPES} from './domain';

// eslint-disable-next-line complexity
export const createSingleParameterSchema = param => {
  // Suggested values (enum)
  if (param.suggestedValues?.length) {
    return z.enum(param.suggestedValues);
  }

  switch (param.type) {
    case API_PARAMETERS_TYPES.TEXT:
    case API_PARAMETERS_TYPES.ANY:
      return z.string();

    case API_PARAMETERS_TYPES.NUMBER:
      return z.coerce.number();

    case API_PARAMETERS_TYPES.LOGICAL:
      return z.union([z.literal('True'), z.literal('False')]);

    case API_PARAMETERS_TYPES.BINARY:
      return z.union([z.literal('0'), z.literal('1')]);

    case API_PARAMETERS_TYPES.DATE:
    case API_PARAMETERS_TYPES.DATETIME:
      return z.string().refine(v => !Number.isNaN(Date.parse(v)), 'Invalid date');

    case API_PARAMETERS_TYPES.DATETIMEZONE:
      return z.object({
        datetime: z.string().refine(v => !Number.isNaN(Date.parse(v)), 'Invalid datetime'),
        timezone: z.string().min(1)
      });

    case API_PARAMETERS_TYPES.DURATION:
      return z.object({
        days: z.coerce.number().int().min(0),
        hours: z.coerce.number().int().min(0).max(23),
        minutes: z.coerce.number().int().min(0).max(59)
      });

    default:
      return z.any();
  }
};

export const createParametersSchema = parameters => {
  return z.object({
    parameters: z.object(Object.fromEntries(parameters.map(p => [p.name, createSingleParameterSchema(p)])))
  });
};
